module.exports = __webpack_public_path__ + "static/media/Reward.7ed07871.svg";